import { render, staticRenderFns } from "./PaginationButton.vue?vue&type=template&id=0243338e&scoped=true&"
import script from "./PaginationButton.vue?vue&type=script&lang=js&"
export * from "./PaginationButton.vue?vue&type=script&lang=js&"
import style0 from "./PaginationButton.vue?vue&type=style&index=0&id=0243338e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243338e",
  null
  
)

export default component.exports